import { render, staticRenderFns } from "./HoldingCrear.vue?vue&type=template&id=1a105701&scoped=true"
import script from "./HoldingCrear.vue?vue&type=script&lang=js"
export * from "./HoldingCrear.vue?vue&type=script&lang=js"
import style0 from "./HoldingCrear.vue?vue&type=style&index=0&id=1a105701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a105701",
  null
  
)

export default component.exports